import {hoistCmp, uses} from '@xh/hoist/core';
import {WorkflowEditorModel} from './WorkflowEditorModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {form, SubformsFieldModel} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {select, switchInput, textInput} from '@xh/hoist/desktop/cmp/input';
import {div, filler, hbox} from '@xh/hoist/cmp/layout';
import './WorkflowEditor.scss';

export const workflowEditor = hoistCmp.factory({
    model: uses(WorkflowEditorModel),
    className: 'workflows-editor',
    render({model, className}) {
        return dialog({
            style: {
                width: 300,
                height: 'fit-content'
            },
            isOpen: model.isOpen,
            onClose: () => model.close(),
            canEscapeKeyClose: false,
            canOutsideClickClose: false,
            title: (model.isEditMode ? 'Edit' : 'Add') + ' Workflow',
            icon: model.isEditMode ? Icon.edit() : Icon.add(),
            item: panel({
                item: editForm(),
                bbar: bbar(),
                mask: model.apiTask
            })
        });
    }
});

const editForm = hoistCmp.factory<WorkflowEditorModel>(({model}) =>
    form({
        model: model.formModel,
        fieldDefaults: {minimal: true, commitOnChange: true},
        items: [
            formField({field: 'name', item: textInput()}),
            formField({
                field: 'command',
                item: select({options: model.commands, enableFilter: false})
            }),
            hbox(
                formField({field: 'schedule', flex: 1, item: textInput()}),
                formField({
                    field: 'isEnabled',
                    label: null,
                    item: switchInput({style: {marginTop: 22}})
                })
            ),
            div({item: model.description, className: 'workflow-editor__description'}),
            commandParamsSubform()
        ]
    })
);

const commandParamsSubform = hoistCmp.factory<WorkflowEditorModel>(({model}) => {
    const params = model.formModel.fields.commandParams as SubformsFieldModel;
    return panel({
        compactHeader: true,
        title: 'Parameters',
        headerItems: [
            button({
                height: 20,
                minHeight: 20,
                marginRight: 5,
                icon: Icon.plus(),
                text: 'Add',
                minimal: false,
                intent: 'success',
                onClick: () => {
                    params.add();
                    model.formModel.validateAsync();
                }
            })
        ],
        item: div({
            className: 'workflow-editor__sub-form',
            items: params.value.map(param =>
                form({
                    model: param,
                    fieldDefaults: {label: null, minimal: true},
                    item: hbox({
                        className: 'workflow-editor__item-form',
                        items: [
                            formField({field: 'key', item: textInput(), flex: 1}),
                            formField({field: 'value', item: textInput(), flex: 1}),
                            button({
                                icon: Icon.delete(),
                                intent: 'danger',
                                onClick: () => params.remove(param)
                            })
                        ]
                    })
                })
            )
        })
    });
});

const bbar = hoistCmp.factory<WorkflowEditorModel>(({model}) =>
    toolbar(
        filler(),
        button({text: 'Cancel', onClick: () => model.close()}),
        button({
            text: 'Save',
            icon: Icon.save(),
            intent: 'primary',
            disabled: !model.formModel.isValid,
            onClick: () => model.save()
        })
    )
);
